import { render, staticRenderFns } from "./PartnerDetails.vue?vue&type=template&id=083afb4c&scoped=true"
import script from "./PartnerDetails.vue?vue&type=script&lang=js"
export * from "./PartnerDetails.vue?vue&type=script&lang=js"
import style0 from "./PartnerDetails.vue?vue&type=style&index=0&id=083afb4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083afb4c",
  null
  
)

export default component.exports